import shallow from 'zustand/shallow';
import { SectionInterface, SectionNomenklature, TireRackItemI } from '../../../../store/types/store';
import { useWindowProperty } from '../../../../utils/hooks/useWidnowProperty';
import { getSumWindowDebug } from '../../../../utils/utils';
import styles from './SpecificationPanel.module.scss';
import useSectionsBySide from './hooks/useSectionsBySide';
import { useShelvingStore, useStoreSystem, useStoreRoom } from '../../../../store';


export const SpecificationBySections = () => {

       const { proMode } = useStoreSystem(
           (state) => ({
               proMode: state.proMode,
           }),
           shallow
       );
       const windowDebug = useWindowProperty("debug", false);
    const sectionsList = useSectionsBySide();
    const { parts } = useStoreSystem((state) => ({
        parts: state.parts,
        setBooleanSystemProperties: state.setBooleanSystemProperties,
        generalListSpecification: state.generalListSpecification,
    }), shallow)

    const {
        sectionsNomenklatureBack,
        sectionsNomenklatureFront,
        sectionsNomenklatureLeft,
        sectionsNomenklatureRight
    } = useShelvingStore((state) => ({
        getCurrentShelving: state.getCurrentShelving,
        shelvings: state.shelving,
        sectionsNomenklatureBack: state.shelving.back.sectionsNomenklature,
        sectionsNomenklatureFront: state.shelving.front.sectionsNomenklature,
        sectionsNomenklatureLeft: state.shelving.left.sectionsNomenklature,
        sectionsNomenklatureRight: state.shelving.right.sectionsNomenklature,
    }), shallow);

    const sectionsNomenklature = [...sectionsNomenklatureBack, ...sectionsNomenklatureFront, ...sectionsNomenklatureLeft, ...sectionsNomenklatureRight];

    const { tireRacks } = useStoreRoom((state) => ({
        tireRacks: state.tireRacks,
    }), shallow);


    const renderSectionItems = (section: SectionInterface) => {
        const stacked: { id: number, label: string, count: number, price: number, parts: { id: number; label: string, price: number, count: number }[] }[] = [];

        stacked.push(...section.items.reduce((acc, currentValue, currentIndex, array) => (acc.filter(({ id }: any) => id === currentValue.bitrixId).length === 0 ? [...acc, {
            id: currentValue.bitrixId,
            label: currentValue.name,
            count: array.filter(({ bitrixId }: any) => bitrixId === currentValue.bitrixId).length,
            price: currentValue.price,
            parts: array
                .filter(({ bitrixId }: any) => bitrixId === currentValue.bitrixId)
                .flatMap((item) => {
                    return [...(item.brackets.left.isVisible ? item.brackets.left.elements : []),
                        ...(item.brackets.right.isVisible ? item.brackets.right.elements : []),
                        ...(() => {
                            return item.parts.filter((element) => {
                                return item.edges?.filter((el) => el.bitrixId === element.bitrixId) !== undefined;
                            });
                        })(),
                    ]
                })
                .reduce((acc, currentValue, currentIndex, array) => (acc.filter(({ id }: any) => id === currentValue.bitrixId).length === 0 ?
                    [...acc, {
                        id: currentValue.bitrixId,
                        //TODO пока any не разбирался какой тип
                        label: parts?.find((p: any) => p.BITRIX_OFFER_ID === currentValue.bitrixId)?.NAME || '',
                        price: parts?.find((p: any) => p.BITRIX_OFFER_ID === currentValue.bitrixId)?.PRICE || 0,
                        count: array.filter(({ bitrixId }: any) => bitrixId === currentValue.bitrixId).length,
                    }] : acc), [] as any)
        }] : acc), [] as any))

        return stacked.map((sectionItem) => {
            return (
                <div key={sectionItem.id} className={styles.sectionItem}>
                    <div>
                        <b className={styles.item}>
                            <span>{sectionItem.label}</span>
                            <span>{sectionItem.count} шт.
                                {getSumWindowDebug(windowDebug, sectionItem.price, sectionItem.count)}
                            </span>
                        </b>
                    </div>

                    {sectionItem.parts.map(({ id, count, price, label }) => (
                        <div key={id} className={styles.item}>
                            <span>{label}</span>
                            <span>{count} шт.
                                {getSumWindowDebug(windowDebug, price, count)}
                            </span>
                        </div>
                    ))}
                </div>
            )
        })
    }
    const getFullSumSection = (section: SectionInterface, sectionIndex: number, sectionsNomenklature: SectionNomenklature[]) => {
        let sum = 0
        section.items.forEach(item => {
            //Подсчет суммы элементов (полки и т.д.)
            item.parts.forEach(part => {
                sum += part.price || 0
            })
            sum += item.price

            //Подсчет суммы кронштейнов
            if (item.brackets.right.isVisible) {
                item.brackets.right.elements.forEach(element => {
                    sum += element.price
                })
            }
            if (item.brackets.left.isVisible) {
                item.brackets.left.elements.forEach(element => {
                    sum += element.price
                })
            }

            const parts = item.parts.filter((element) => {
                return item.edges?.filter((el) => el.bitrixId === element.bitrixId) !== undefined;
            });

            parts.forEach(element => {
                sum += element.price
            });
        })

        const nomenklature = sectionsNomenklature.find(({ sectionId }) => sectionId === section.id)
        if (!nomenklature) {
            return
        }
        //Подсчет соединителей
        if (nomenklature?.connector && nomenklature?.connectorPrice) {
            sum += (nomenklature.connector * nomenklature.connectorPrice)
        }

        //Подсчет горизонталей и вертикалей
        sum += nomenklature.vertical['480'] * (nomenklature.vertical?.price480 || 0)
        sum += nomenklature.vertical['600'] * (nomenklature.vertical?.price600 || 0)
        sum += nomenklature.vertical['800'] * (nomenklature.vertical?.price800 || 0)
        sum += nomenklature.vertical['1200'] * (nomenklature.vertical?.price1200 || 0)
        sum += nomenklature.horizontal['480'] * (nomenklature.horizontal?.price480 || 0)
        sum += nomenklature.horizontal['600'] * (nomenklature.horizontal?.price600 || 0)
        sum += nomenklature.horizontal['800'] * (nomenklature.horizontal?.price800 || 0)
        sum += nomenklature.horizontal['1200'] * (nomenklature.horizontal?.price1200 || 0)

        return sum
    }

    const renderSectionRacks = (sectionItem: SectionInterface) => {
        const nomenklature = sectionsNomenklature.find(({ sectionId }) => sectionId === sectionItem.id)

        if (!nomenklature) return <div />

        return <div>
            {(!!nomenklature.horizontal["480"]) && (
              <span className={styles.item}>
                    <span>Горизонтальная направляющая 480</span>
                    <span>{nomenklature.horizontal["480"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.horizontal?.price480 || 0, nomenklature.horizontal['480'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.horizontal["600"]) && (
                <span className={styles.item}>
                    <span>Горизонтальная направляющая 600</span>
                    <span>{nomenklature.horizontal["600"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.horizontal?.price600 || 0, nomenklature.horizontal['600'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.horizontal["800"]) && (
                <span className={styles.item}>
                    <span>Горизонтальная направляющая 800</span>
                    <span>{nomenklature.horizontal["800"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.horizontal?.price800 || 0, nomenklature.horizontal['800'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.horizontal["1200"]) && (
                <span className={styles.item}>
                    <span>Горизонтальная направляющая 1200</span>
                    <span>{nomenklature.horizontal["1200"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.horizontal?.price1200 || 0, nomenklature.horizontal['1200'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.vertical["480"]) && (
              <span className={styles.item}>
                    <span>Вертикальная направляющая 480</span>
                    <span>{nomenklature.vertical["480"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.vertical?.price480 || 0, nomenklature.vertical['480'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.vertical["600"]) && (
                <span className={styles.item}>
                    <span>Вертикальная направляющая 600</span>
                    <span>{nomenklature.vertical["600"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.vertical?.price600 || 0, nomenklature.vertical['600'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.vertical["800"]) && (
                <span className={styles.item}>
                    <span>Вертикальная направляющая 800</span>
                    <span>{nomenklature.vertical["800"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.vertical?.price800 || 0, nomenklature.vertical['800'])}
                    </span>
                </span>
            )}
            {(!!nomenklature.vertical["1200"]) && (
                <span className={styles.item}>
                    <span>Вертикальная направляющая 1200</span>
                    <span>{nomenklature.vertical["1200"]} шт.
                        {getSumWindowDebug(windowDebug, nomenklature.vertical?.price1200 || 0, nomenklature.vertical['1200'])}
                    </span>
                </span>
            )}
            {nomenklature.connector !== 0 && (
                <span className={styles.item}>
                    <span>Соединитель</span>
                    <span>{nomenklature.connector} шт.
                        {getSumWindowDebug(windowDebug, nomenklature?.connectorPrice || 0, nomenklature.connector)}
                    </span>
                </span>
            )}
            {((nomenklature.remainderRight !== undefined) && (nomenklature.remainderRight > 0)) &&
                <span
                    className={styles.remainder}>Требуется отпил правой стойки на {nomenklature.remainderRight} мм</span>}
            {((nomenklature.remainderLeft !== undefined) && (nomenklature.remainderLeft > 0)) &&
                <span
                    className={styles.remainder}>Требуется отпил левой стойки на {nomenklature.remainderLeft} мм</span>}
        </div>
    }

    const renderTireRackItems = (tireRack: TireRackItemI) => {
        const tireRackItems: { id: string, label: string, count: number, price: number, parts: { id: number; label: string, price: number, count: number }[] }[] = [];

        // Add the main tire rack item
        tireRackItems.push({
            id: tireRack.id,
            label: tireRack.nameNomenkl || tireRack.name,
            count: 1,
            price: tireRack.pricing?.base_price || 0,
            parts: tireRack.parts?.map(part => ({
                id: part.id,
                label: part.name,
                price: part.price,
                count: 1
            })) || []
        });

        return tireRackItems.map((tireRackItem) => {
            return (
                <div key={tireRackItem.id} className={styles.sectionItem}>
                    <div>
                        <b className={styles.item}>
                            <span>{tireRackItem.label}</span>
                            <span>{tireRackItem.count} шт.
                                {getSumWindowDebug(windowDebug, tireRackItem.price, tireRackItem.count)}
                            </span>
                        </b>
                    </div>

                    {tireRackItem.parts.map(({ id, count, price, label }) => (
                        <div key={id} className={styles.item}>
                            <span>{label}</span>
                            <span>{count} шт.
                                {getSumWindowDebug(windowDebug, price, count)}
                            </span>
                        </div>
                    ))}
                </div>
            )
        })
    }

    const getTireRackSum = (tireRack: TireRackItemI) => {
        let sum = tireRack.pricing?.base_price || 0;
        tireRack.parts?.forEach(part => {
            sum += part.price;
        });
        return sum;
    }


    return (
        <table className={styles.sectionsTable}>
            <thead className={styles.sectionsTableHeader}>
                <td>Секция</td>
                {proMode ? <td>Вид</td> : null}
                <td>Размер</td>
                <td>Товар</td>
                <td>Направляющая</td>
                {windowDebug && <td>Сумма</td>}
            </thead>
            <tbody>
                {sectionsList.map((section, index) => {
                    if (section.isIndent) {
                        return null
                    }
                    return (
                        <tr key={section.id} className={styles.section}>
                            <td className={styles.sectionName}>
                                <div className={styles.number}>Секция {index + 1}</div>
                            </td>
                            {proMode ? <td className={styles.sectionSide}>
                                <div className={styles.sectionSizes}>
                                    {section.side === 'left' && 'Слева'}
                                    {section.side === 'front' && 'Спереди'}
                                    {section.side === 'right' && 'Справа'}
                                    {section.side === 'back' && 'Сзади'}
                                </div>
                            </td> :
                                null
                            }
                            <td className={styles.sectionSize}>
                                <div className={styles.sectionSizes}>
                                    {section.width}
                                    x
                                    {section.height > section.leftRackHeight ? section.height : section.leftRackHeight}
                                    мм
                                </div>
                            </td>
                            <td className={styles.sectionItemsCell}>
                                <div
                                    className={[styles.sectionItems, windowDebug && styles.sectionItemsDebug].filter(Boolean).join(' ')}>
                                    {renderSectionItems(section)}
                                </div>
                            </td>
                            <td className={styles.sectionRacks}>
                                {renderSectionRacks(section)}
                            </td>
                            {windowDebug ?
                                <td>
                                    {getFullSumSection(section, index + 1, sectionsNomenklature)} р.
                                </td> :
                                null}
                        </tr>)
                })}
                {proMode && tireRacks.map((tireRack, index) => (
                    <tr key={tireRack.id} className={styles.section}>
                        <td className={styles.sectionName}>
                            <div className={styles.number}>Стойка для шин {index + 1}</div>
                        </td>
                        <td className={styles.sectionSide}>
                            <div className={styles.sectionSizes}>
                                На полу
                            </div>
                        </td>
                        <td className={styles.sectionSize}>
                            <div className={styles.sectionSizes}>
                                {tireRack.width}
                                x
                                {tireRack.height}
                                x
                                {tireRack.depth}
                                мм
                            </div>
                        </td>
                        <td className={styles.sectionItemsCell}>
                            <div
                                className={[styles.sectionItems, windowDebug && styles.sectionItemsDebug].filter(Boolean).join(' ')}>
                                {renderTireRackItems(tireRack)}
                            </div>
                        </td>
                        <td className={styles.sectionRacks}>
                            {/* TireRacks don't have rails/guides like sections */}
                        </td>
                        {windowDebug ?
                            <td>
                                {getTireRackSum(tireRack)} р.
                            </td> :
                            null}
                    </tr>
                ))}
            </tbody>
        </table>
    )
}
